import { render } from "./ProfilSingle.vue?vue&type=template&id=67890176"
import script from "./ProfilSingle.vue?vue&type=script&lang=js"
export * from "./ProfilSingle.vue?vue&type=script&lang=js"

import exportComponent from "/home/jbenes/PhpstormProjects/VUE/VUE_Neustadt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__